import { render } from "./MarketplaceLayout.vue?vue&type=template&id=babe9ab4&scoped=true"
import script from "./MarketplaceLayout.vue?vue&type=script&lang=js"
export * from "./MarketplaceLayout.vue?vue&type=script&lang=js"

import "./MarketplaceLayout.vue?vue&type=style&index=0&id=babe9ab4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-babe9ab4"]])

export default __exports__